import { useTranslation } from "next-i18next";
import { FC } from "react";

import {
  BoxImageFirstListType,
  i18translateType,
} from "../../@types/types-body";

export const BoxVideoFirstImage: FC<BoxImageFirstListType> = ({
  namespace,
  object,
  image,
  section,
}) => {
  const { t }: i18translateType = useTranslation(namespace);

  return (
    <div className="mx-auto relative container">
      <div className="grid grid-cols-12 grid-flow-row-dense lg:grid-flow-col-dense gap-1 content-between">
        <div className="col-span-12 lg:col-span-6 order-last md:px-12 text-justify mt-8">
          <ul className="list-disc list-outside">
            {Object.keys(t(`${object}`, { returnObjects: true })).map(
              (objectValue, index) => (
                <li key={`${object}-${objectValue}-${index}`}>
                  {t(`${object}.${objectValue}`)}
                </li>
              )
            )}
          </ul>
        </div>
        <div className="col-span-12 lg:col-span-6 lg:mb-0 relative h-full">
          <video className="w-full rounded-2xl" autoPlay loop preload={"metadata"} playsInline muted>
            <source src={image} type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
};
